import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import React from 'react';
import { observer } from 'mobx-react';
import { fetchIpoDetailbySeoName } from 'src/common/store/ipo.service';
import IPOPage from '../components/IPODetailsPage';

const sendSeoData = ({
  ipo,
  seo = false,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <IPOPage ipo={ipo} queryParam={ipo.seoName} queryType="seoName" seo={seo} />
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  query,
  req,
  res,
}) => {
  // Fetch data from external API
  let data = {};
  // const ipoId: string = query.ipoId as string;
  const seoName: string = query.seoName as string;
  const redirectMap = {
    'oravel-stays': '/oyo-oravel-stays-limited',
    bikaji: '/bikaji-foods-international',
    'employe-esaf-small-finance-bank-ipo':
      '/employee-esaf-small-finance-bank-ipo',
    'protean-egov-echnologies-ipo': '/protean-egov-technologies-ipo',
    'swiggy-limited-ipo': '/swiggy-ipo',
  };
  const isEmployeeSlug = /\b(employee|emp)\b/i.test(seoName);
  const updatedSlug = isEmployeeSlug ? seoName
  .replace(/\b(employee|emp)\b/gi, "")
  .replace(/-{2,}/g, "-")
  .replace(/^-+|-+$/g, "")
  .replace(/\/ipo\/-/, "/ipo/") : seoName;
  const redirectionURL = `${process.env.UPSTOX_IPO_URL_WEBSITE}${updatedSlug}/`;
  return {
    redirect: {
      destination: redirectionURL,
      statusCode: 301,
    },
  };
  const redirectionUrl = redirectMap[seoName];
  if (redirectionUrl) {
    return {
      redirect: {
        destination: redirectionUrl,
        statusCode: 301,
      },
    };
  }

  // const response  = await fetchIpoDetails(ipoId);
  const response = await fetchIpoDetailbySeoName(seoName);
  if (response.success) {
    data = response.data;
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=1800, max-age=300, stale-while-revalidate=59',
    );
  } else {
    res.setHeader(
      'Cache-Control',
      'no-cache, no-store, max-age=0, must-revalidate',
    );
  }
  let seo = false;
  if (process.env?.env && process.env?.env?.toLowerCase() == 'prod') {
    seo = true;
  } else {
    seo = false;
  }
  // Pass data to the page via props
  return { props: { ipo: data, seo: seo } };
};

export default observer(sendSeoData);
